import React, { useEffect, useReducer, useState } from 'react'
import { Link } from 'react-router-dom'
import { Button } from '@/Components/ui/button'
import UploadBox from '@/Components/UploadBox'
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/Components/ui/select'
import HeaderCard from '@/Components/HeaderCard'
import BodyCard from '@/Components/BodyCard'
import TextLabel from '@/Components/Common/TextLabel'
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/Components/ui/table'
import assets from '@/assets/assets'
import { format } from 'date-fns'
import Constant from '@/utils/Constant'
import Loader from '@/Components/Common/Loader'
import CreateBulkPagination from './CreateBulkPagination'
import Axios from '@/Axios'
import BulkUploadService from '@/Service/BulkUploadService'
import { generateRandomeString } from '@/utils/helper'

const CreateBulkUpload = () => {
    const [event, updateEvent] = useReducer(
        (prev, next) => {
            return { ...prev, ...next }
        },
        {
            importTemplate: '',
            file: null,
            isReadyForImport: false,
            isImporting: false,
            currentPage: 1,
            currentErrorTablePage: 1,
            isDataPreparing: false,
            uploadedData: [],
            uniqueUploadedData: [],
            paginatedData: [],
            errorData: [],
            errorMessages: [],
            paginatedErrorMessages: [],
        }
    )

    useEffect(() => {
        if (event.errorMessages.length > 0) {
            const startIndex = 0
            const endIndex = startIndex + Constant.PAGINATION_SIZE
            const paginatedData = event.errorMessages.slice(startIndex, endIndex)
            updateEvent({ paginatedErrorMessages: paginatedData })
        }
    }, [event.errorMessages])

    useEffect(() => {
        if (event.uploadedData.length > 0 && event.errorData.length == 0) {
            updateEvent({ isReadyForImport: true })
        }
    }, [event.uploadedData])

    const chunkArray = (array, chunkSize) => {
        const chunks = []
        for (let i = 0; i < array.length; i += chunkSize) {
            chunks.push(array.slice(i, i + chunkSize))
        }
        return chunks
    }

    const sendChunkToValidatedData = async (chunk) => {
        try {

            const response = await BulkUploadService.validateWorkAllocationData(chunk)
            return response.data.data
        } catch {}
        return {
            preview_data: [],
            error_warnings: [],
            error_warning_data: [],
        }
    }

    const uploadInChunks = async (data, chunkSize = 500, onProgress) => {
        const chunks = chunkArray(data, chunkSize)
        const allResults = {
            preview_data: [],
            warnings: [],
            warning_data: [],
        }

        for (let i = 0; i < chunks.length; i++) {
            const chunk = chunks[i]
            try {
                const response = await sendChunkToValidatedData(chunk)
                if (onProgress) {
                    onProgress(i + 1, chunks.length)
                }
                allResults.preview_data.push(...response.preview_data)
                allResults.warnings.push(...response.error_warnings)
                allResults.warning_data.push(...response.error_warning_data)
            } catch (err) {
                console.error(`Chunk ${i + 1} failed`, err)
            }
        }

        return allResults
    }

    const handleExcelUpload = async (prepareData = []) => {
        try {
            const startIndex = 0
            const endIndex = startIndex + Constant.PAGINATION_SIZE

            const results = await uploadInChunks(prepareData.length > 0 ? prepareData : event.uploadedData, 500, (current, total) => {
                updateEvent({ isDataPreparing: true })
                // console.log(`Uploading chunk ${current} of ${total}`)
            })
            const paginatedWarningData = results.warnings.slice(startIndex, endIndex)
            const paginatedUploadData = prepareData.slice(startIndex, endIndex)
            updateEvent({
                isDataPreparing: false,
                paginatedData: paginatedUploadData,
                uploadedData: results.preview_data,
                errorMessages: results.warnings,
                paginatedErrorMessages: paginatedWarningData,
                errorData: results.warning_data,
            })
        } catch (err) {
            console.error('Upload failed:', err)
        }
    }

    const handleDownloadTemplate = () => {
        // Column formate could be like this : [{ name: '', date: '', amount: '' }]
        switch (selectedDocumentType) {
            case DocumentTypeEnum.DAILY_WORK_LOG:
                const dailyWorkLogColumns = [{ NAME: '', DATE: '', AMOUNT: '' }]
                if (selectedProjectId == DocumentTypeEnum.NOT_SELECTED) {
                    toast.info('Please select project')
                    return false
                }
                ExportExcel(dailyWorkLogColumns, Date.now())
                break
        }
    }

    const handleImportBulkUpload = async () => {
        try {
            updateEvent({ isImporting: true })

            //Upload file
            const formData = new FormData()
            formData.append('file', event.file)
            formData.append('is_private', 0)
            formData.append('folder', 'Home')
            formData.append('doctype', 'Chart Upload')
            formData.append('docname', 'new-chart-upload-' + generateRandomeString())
            formData.append('fieldname', 'import_file')
            const uploadFile = await BulkUploadService.uploadFile(formData)
            console.log('response : ', uploadFile)
            if(uploadFile.data.success){
                let bulkUploadPostData = {
                    docstatus: 0,
                    doctype: 'Chart Upload',
                    name: 'new-chart-upload-' + generateRandomeString(),
                    document_type: 'Work Allocation',
                    status: 'Pending',
                    role: '',
                    show_failed_logs: 0,
                    import_file: uploadFile.data.data.file_url,
                    template_options: '',
                    file_name : uploadFile.data.data.name
                }
                const bulkUpload = await BulkUploadService.createBulkUploadRecord(bulkUploadPostData)
                console.log('bulkUpload : ', bulkUpload)
                if(bulkUpload.data.success){
                    try {
                        // let importFormData = {
                        //     import_file: uploadFile.data.data.file_url,
                        //     upload_doctype : "Chart Upload",
                        //     upload_docname : bulkUpload.data.data.name
                        // }
                        const importFormData = new FormData()
                        importFormData.append('file', event.file)
                        importFormData.append('upload_doctype', "Chart Upload")
                        importFormData.append('upload_docname', bulkUpload.data.data.name)
                        const response = await BulkUploadService.importData(importFormData)
                        console.log('response', response)
                        return response.data.data
                    } catch {}
                    return {
                        preview_data: [],
                        error_warnings: [],
                        error_warning_data: [],
                    }
                    // const results = await importInChunks(event.uploadedData, body, 500, (current, total) => {
                    //     updateEvent({ isImporting: true })
                    //     // console.log(`Uploading chunk ${current} of ${total}`)
                    // })
                }
                
            }
            
            
            
        } catch (err) {
            console.error('import failed:', err)
        }
        updateEvent({ isImporting: false })
    }

    const importInChunks = async (data, body, chunkSize = 500, onProgress) => {
        const chunks = chunkArray(data, chunkSize)
        const allResults = {
            preview_data: [],
            warnings: [],
            warning_data: [],
        }

        for (let i = 0; i < chunks.length; i++) {
            const chunk = chunks[i]
            try {
                const response = await sendChunkToImportData(chunk, body)
                if (onProgress) {
                    onProgress(i + 1, chunks.length)
                }
                allResults.preview_data.push(...response.preview_data)
                allResults.warnings.push(...response.error_warnings)
                allResults.warning_data.push(...response.error_warning_data)
            } catch (err) {
                console.error(`Chunk ${i + 1} failed`, err)
            }
        }

        return allResults
    }

    const sendChunkToImportData = async (chunk, body) => {
        try {
            body['data'] = chunk 
            const response = await BulkUploadService.importData(body)
            console.log('response', response)
            return response.data.data
        } catch {}
        return {
            preview_data: [],
            error_warnings: [],
            error_warning_data: [],
        }
    }

    return (
        <>
            <HeaderCard>
                <div className="flex items-center justify-end gap-2">
                    {event.isReadyForImport && (
                        <Button
                            className="bg-primary-purpal hover:bg-primary-purpal px-4"
                            onClick={handleImportBulkUpload}
                            iconType="Import"
                            disabled={event.isImporting}
                        >
                            Import {event.isImporting && <Loader fullScreen={false} />}
                        </Button>
                    )}
                </div>
            </HeaderCard>
            <BodyCard>
                <div>
                    <div className="grid grid-cols-4 gap-2">
                        <Select defaultValue="work_allocation">
                            <SelectTrigger>
                                <SelectValue placeholder="Document Type" />
                            </SelectTrigger>
                            <SelectContent>
                                <SelectItem value="work_allocation">Work Allocation</SelectItem>
                            </SelectContent>
                        </Select>
                        <Button className="w-fit bg-primary-purpal hover:bg-primary-purpal" onClick={handleDownloadTemplate}>
                            Download Template
                        </Button>
                    </div>
                    <hr className="my-4" />
                    <UploadBox
                        isDataProcessing={(isProcessing) => {
                            updateEvent({ isDataPreparing: isProcessing })
                        }}
                        onFileUpload={(file) => updateEvent({ file: file })}
                        getUploadedData={(data) => {
                            updateEvent({ isDataPreparing: true })
                            let prepareData = []
                            data.map((dt) => {
                                let obj = {}
                                assets.data.workAllocationHeaders.map((val) => {
                                    if (val.key == 'arrived_date') {
                                        obj[val.key] =
                                            dt[val.value] !== undefined ? format(new Date(dt[val.value]), Constant.DATE_FORMAT_WITH_TIME) : ''
                                    } else {
                                        obj[val.key] = dt[val.value] !== undefined ? dt[val.value] : ''
                                    }
                                })
                                prepareData.push(obj)
                            })
                            handleExcelUpload(prepareData)
                        }}
                        removedFile={() =>
                            updateEvent({
                                isReadyForImport: false,
                                currentPage: 1,
                                currentErrorTablePage: 1,
                                isDataPreparing: false,
                                uploadedData: [],
                                paginatedData: [],
                                errorData: [],
                                errorMessages: [],
                                paginatedErrorMessages: [],
                                file: null,
                            })
                        }
                    />
                </div>
                {event.paginatedData.length > 0 && (
                    <div className="mt-3 ">
                        <TextLabel text={`Preview`} />
                        <small className="text-red-500">Make sure to hit the 'Import' button or the data won’t be saved.</small>
                        <div className="overflow-auto overflow-card-scroll">
                            <Table className="mt-2" style={{ width: '150%' }}>
                                <TableHeader>
                                    <TableRow className="border">
                                        <TableHead key="BULK_UPLOAD_HEAD_0" className="border text-left text-[13px] font-bold">
                                            Sr.No
                                        </TableHead>
                                        {assets.data.workAllocationHeaders.map((value, i) => (
                                            <TableHead key={'BULK_UPLOAD_HEAD_' + (i + 1)} className="border text-left text-[13px] font-bold">
                                                {value.value}
                                            </TableHead>
                                        ))}
                                    </TableRow>
                                </TableHeader>
                                <TableBody>
                                    {event.paginatedData.map((row, currentIndex) => (
                                        <TableRow
                                            key={
                                                'BULK_UPLOAD_DATA_' +
                                                (currentIndex + 1 + (Constant.PAGINATION_SIZE * event.currentPage - Constant.PAGINATION_SIZE))
                                            }
                                            className="border"
                                        >
                                            <TableCell className="border text-[13px] text-left py-2">
                                                {currentIndex + 1 + (Constant.PAGINATION_SIZE * event.currentPage - Constant.PAGINATION_SIZE)}
                                            </TableCell>
                                            <TableCell className="border text-[13px] text-left py-2">{row['client']}</TableCell>
                                            <TableCell className="border text-[13px] text-left py-2">{row['mr_number']}</TableCell>
                                            <TableCell className="border text-[13px] text-left py-2">{row['patient_name']}</TableCell>
                                            <TableCell className="border text-[13px] text-left py-2">{row['arrived_date']}</TableCell>
                                            <TableCell className="border text-[13px] text-left py-2">{row['payor_type_hchb']}</TableCell>
                                            <TableCell className="border text-[13px] text-left py-2">{row['assessment_type']}</TableCell>
                                            <TableCell className="border text-[13px] text-left py-2">{row['status']}</TableCell>
                                            <TableCell className="border text-[13px] text-left py-2">{row['priority']}</TableCell>
                                            <TableCell className="border text-[13px] text-left py-2">{row['coder']}</TableCell>
                                            <TableCell className="border text-[13px] text-left py-2">{row['production_tl']}</TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </div>
                        <CreateBulkPagination
                            totalCount={event.uploadedData.length}
                            onPageChange={(currentPage) => {
                                const startIndex = (currentPage - 1) * Constant.PAGINATION_SIZE
                                const endIndex = startIndex + Constant.PAGINATION_SIZE
                                const paginatedData = event.uploadedData.slice(startIndex, endIndex)
                                updateEvent({ paginatedData: paginatedData, currentPage })
                            }}
                        />
                    </div>
                )}

                {event.paginatedErrorMessages.length > 0 && (
                    <div className="mt-3 ">
                        <TextLabel text={`Import File Errors and Warnings`} />
                        <div className="overflow-auto overflow-card-scroll">
                            <Table className="mt-2">
                                <TableHeader>
                                    <TableRow className="border">
                                        <TableHead key="BULK_UPLOAD_ERROR_0" className="border text-left text-[13px] font-bold w-20">
                                            Sr.No
                                        </TableHead>
                                        {assets.data.workAllocationImportErrors.map((value, i) => (
                                            <TableHead key={'BULK_UPLOAD_ERROR_' + (i + 1)} className="border text-left text-[13px] font-bold">
                                                {value.value}
                                            </TableHead>
                                        ))}
                                    </TableRow>
                                </TableHeader>
                                <TableBody>
                                    {event.paginatedErrorMessages.map((row, currentIndex) => (
                                        <TableRow
                                            key={
                                                'BULK_UPLOAD_ERROR_' +
                                                (currentIndex +
                                                    1 +
                                                    (Constant.PAGINATION_SIZE * event.currentErrorTablePage - Constant.PAGINATION_SIZE))
                                            }
                                            className="border"
                                        >
                                            <TableCell className="border text-[13px] text-left py-2">
                                                {currentIndex +
                                                    1 +
                                                    (Constant.PAGINATION_SIZE * event.currentErrorTablePage - Constant.PAGINATION_SIZE)}
                                            </TableCell>
                                            <TableCell className="border text-[13px] text-left py-2" dangerouslySetInnerHTML={{ __html: row }} />
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </div>
                        <CreateBulkPagination
                            totalCount={event.errorMessages.length}
                            onPageChange={(currentPage) => {
                                const startIndex = (currentPage - 1) * Constant.PAGINATION_SIZE
                                const endIndex = startIndex + Constant.PAGINATION_SIZE
                                const paginatedData = event.errorMessages.slice(startIndex, endIndex)
                                updateEvent({ paginatedErrorMessages: paginatedData, currentErrorTablePage: currentPage })
                            }}
                        />
                    </div>
                )}

                {event.isDataPreparing && (
                    <div className="mt-3 flex gap-3 ">
                        <TextLabel text={`Validating Data...`} /> <Loader fullScreen={false} />
                    </div>
                )}
            </BodyCard>
        </>
    )
}

export default CreateBulkUpload
